import React from 'react';
import { useSelector } from 'react-redux';

import { Modal } from 'antd';

import CloseIcon from '../../../resources/icons/CloseIcon';
import { colorPalette } from '../../../resources/styles/colorPalette';

import { selectDarkMode } from '../../../userBrowserSettings/store/browserSettings.selectors';

// import StartGuideModalContent from '../sidebar/bottomMenu/StartGuideModalContent';

const classes = {
    modalWrapper: 'ai-additional-info-modal-wrapper',
};

const AIOptimizerAdditionalInfoModal = ({ isOpen, handleOpen }) => {
    const darkMode = useSelector(selectDarkMode);

    const closeModalIconColor = darkMode
        ? colorPalette.textColor.dark
        : colorPalette.textColor.light;

    return (
        <Modal
            centered
            forceRender
            open={isOpen}
            onCancel={handleOpen}
            footer={null}
            closeIcon={<CloseIcon color={closeModalIconColor} />}
            wrapClassName={classes.modalWrapper}
            width={'800px'}
        >
            {/* TODO: add a video similar to <StartGuideModalContent /> */}
        </Modal>
    );
};

export default AIOptimizerAdditionalInfoModal;
